import React, { useState, useEffect } from 'react'
import { ajaxPost } from '../../../ajax'

export default function Confirm({token, league, player, onBack, onConfirmed}) {
  const [code, setCode] = useState('')
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const [counter, setCounter] = useState(0)
  const buttonDisabled = code.trim().length < 4

  useEffect(() => {
    var timerId = null
    timerId = counter > 0 && setTimeout(() => setCounter(counter - 1), 1000)
    return () => {
      timerId && clearTimeout(timerId)
    }
  }, [counter])

  const confirmCode = async () => {
    setLoading(true)
    const params = { token: token, player_id: player.id, code: code }
    const response = await ajaxPost(`/plugin/leagues/${league.id}/registrations/confirm`, params)
    const json = await response.json()
    setLoading(false)
    if (json.error) setError(json.error)
    else onConfirmed(json.player)
  }

  const resendCode = async () => {
    setLoading(true)
    const params = { token: token, player_id: player.id }
    const response = await ajaxPost(`/plugin/leagues/${league.id}/registrations/resend`, params)
    const json = await response.json()
    setLoading(false)
    if (json.error) setError(json.error)
    else {
      setError(null)
      setCounter(60)
    }
  }

  const warning = () => {
    if (counter == 0) {
      return <div className='resend'>Didn’t receive verification code?&nbsp;
        <span className='resend__link' onClick={resendCode}>Resend</span>
      </div>
    }
    else {
      return <div className='resend'>
        <span className='resend__sent'>New verification code was sent.&nbsp;</span>{`Send again in ${counter} seconds`}
      </div>
    }
  }

  const checkKeyDown = (e) => {
    if (e.key === 'Enter' && !buttonDisabled) confirmCode()
  }

  return <div className={'confirm-form' + (loading ? ' isLoading' : '')}>
    <div>
      <div className='confirm-title'>Enter Verification Code</div>
      <div className='confirm-desc'>
        {`The code sent to ${player.phone} will verify your ${league.company_name} account through your mobile service provider`}
      </div>
    </div>
    { error && <div className='registration-error'>{error}</div> }
    { loading && <div className='animated-spinner'></div> }
    <div>
      <label className='confirm-label'>
        {`Enter the 4-digit code we sent to ${player.phone}`}
        <input autoFocus placeholder='Code' value={code} onChange={e => setCode(e.target.value)} onKeyDown={checkKeyDown} />
      </label>
      {warning()}
    </div>
    <div className='confirm-buttons'>
      <button className='button back-button' onClick={onBack}>Back</button>
      <button className='button confirm-button' disabled={buttonDisabled} onClick={confirmCode}>Verify</button>
    </div>
  </div>
}
